/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizersave1Inputs */

const en_organizersave1 = /** @type {(inputs: Organizersave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const de_organizersave1 = /** @type {(inputs: Organizersave1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Organizersave1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizersave1 = /** @type {((inputs?: Organizersave1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizersave1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizersave1(inputs)
	return de_organizersave1(inputs)
});
export { organizersave1 as "organizerSave" }